require('./fragment.js');
require('./mixins/payload.js');

PegasusTemplate.PayloadView = PegasusTemplate.FragmentView.extend( PegasusTemplate.PayloadMixin, {
  viewName: 'payload',

  style: ''
});

PegasusTemplate.PayloadView.reopenClass({
  create: function(){
    var result = this._super.apply(this, arguments);
    return result;
  }
});
